import React from 'react';
import { ProductListTemplate } from 'themes/modules/product/pages';
import { ProductListViewStore } from 'modules/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ProductListViewStore(rootStore), 'productListViewStore')
class ProductList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ProductListTemplate {...this.props} viewStore={this.props.productListViewStore} />;
	}
}

export default ProductList;



// WEBPACK FOOTER //
// ./src/modules/product/pages/ProductList.jsx